import { render, staticRenderFns } from "./FooterPublicComponent.vue?vue&type=template&id=21f285f2&lang=pug"
import script from "./FooterPublicComponent.vue?vue&type=script&lang=js"
export * from "./FooterPublicComponent.vue?vue&type=script&lang=js"
import style0 from "./FooterPublicComponent.vue?vue&type=style&index=0&id=21f285f2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports